<template>
    <DashboardContainer>
        <add-campaigns-list/>
    </DashboardContainer>
</template>

<script>
import DashboardContainer from '../containers/DashboardContainer'
import AddCampaignsList from '../components/marketing/AddCampaignsList'

export default {
    name: 'addEmailCampaignsList',
    beforeCreate: function () {
        var auth = this.$storage.get('auth')
        if (!auth) {
            this.$router.push('/login')
        }else{
            if(!auth.token){
                this.$router.push('/login')
            }
        }
    },
    components: {
        DashboardContainer,
        AddCampaignsList,
    }
};
</script>